<wlm-local-grid
  class="generic-grid"
  [gridSettings]="gridSettings"
  [gridData]="attributeValues"
></wlm-local-grid>
